type Props = { error?: string | null; loading: boolean; children: React.ReactNode };

export function Loader({ error, loading, children }: Props) {
  if (loading) {
    return (
      <div className="empty">
        <div className="spinner" role="status" aria-label="Cargando" style={{ margin: "0 auto" }} />
      </div>
    );
  }
  if (error) {
    return (
      <div className="alert alert--error" role="alert">
        {error}
      </div>
    );
  }
  return <>{children}</>;
}
